import { render } from "./CompanyDetails.vue?vue&type=template&id=ac678a80&scoped=true"
import script from "./CompanyDetails.vue?vue&type=script&lang=ts"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-ac678a80"

export default script